<template>
  <div class="good-detail">
    <div class="top">
      <swiper :options="coverSwiper" v-if="detail.img.length">
        <swiper-slide v-for="(item, index) in detail.img" :key="index">
          <div class="image" :style="{ backgroundImage: `url(${item})` }"></div>
        </swiper-slide>
        <div class="pagination" slot="pagination"></div>
      </swiper>
      <div class="right">
        <img src="../assets/img/logo.png" alt class="logo" />
        <span class="name">{{ detail.title }}</span>
        <span class="no">
          商品编号：
          <span>{{ detail.code }}</span>
        </span>
        <span class="no">类型：{{ detail.type }}</span>
        <span class="no">材质：{{ detail.material }}</span>
        <p class="price">
          <i class="el-icon-caret-right"></i>
          ￥{{ detail.price }}
        </p>
        <a class="call" :href="`tel:${shop.consult_tel}`">
          <i class="el-icon-caret-right"></i>
          咨询电话：{{ shop.consult_tel }}
        </a>
        <div class="btn">
          <div @click="toShop(1)">
            <img src="../assets/img/Tmall.png" alt srcset />
            天猫店铺
          </div>
          <div @click="toShop(2)">
            <i class="el-icon-caret-right"></i>
            <img src="../assets/img/weistore.png" alt srcset />
            微店
          </div>
        </div>
      </div>
    </div>
    <div class="detail">
      <h1>设计灵感</h1>
      <div class="rich" v-html="detail.content"></div>
      <ul>
        <li v-for="(item, index) in detail.product_intro" :key="index">
          <div class="right" v-if="index % 2 == 0">
            <!-- <video :src="item.video" v-if="item.video" controls></video> -->
            <img :src="item.img" />
            <div>
              <p class="title">{{ item.title }}</p>
              <p class="desc" v-html="item.content"></p>
            </div>
          </div>
          <div class="left" v-else>
            <div>
              <p class="title">{{ item.title }}</p>
              <p class="desc" v-html="item.content"></p>
            </div>
            <img :src="item.img" alt />
          </div>
        </li>
      </ul>
    </div>
    <div class="swiper-box">
      <p class="title">更多产品</p>
      <hr />
      <div>
        <swiper :options="options" ref="mySwiper" class="pc">
          <swiper-slide
            v-for="(item, index) in detail.more_product"
            :key="index"
            @click.native="todetail(item.id)"
          >
            <img :src="item.img[0]" alt />
            <p class="name">{{ item.title }}</p>
          </swiper-slide>
        </swiper>
        <swiper :options="options1" ref="mySwiper" class="mobile">
          <swiper-slide
            v-for="(item, index) in detail.more_product"
            :key="index"
            @click.native="todetail(item.id)"
          >
            <img :src="item.img[0]" alt />
            <p class="name">{{ item.title }}</p>
          </swiper-slide>
        </swiper>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    let _this = this
    return {
      detail: {},
      shop: JSON.parse(localStorage.getItem('shop')),
      options: {
        slidesPerView: 5,
        spaceBetween: 34,
        autoplay: {
          delay: 3000,
        },
        // loop: true,
        on: {
          transitionEnd: function () {
            _this.active = this.realIndex
          },
        },
      },
      coverSwiper: {
        // loop: true,
        autoplay: {
          delay: 3000,
        },
        pagination: {
          el: '.pagination',
          bulletClass: 'dot',
          bulletActiveClass: 'dot-active',
        },
      },
      options1: {
        slidesPerView: 3,
        spaceBetween: 5,
        autoplay: {
          delay: 3000,
        },
        // loop: true,
        on: {
          transitionEnd: function () {
            _this.active = this.realIndex
          },
        },
      },
    }
  },
  created() {
    this.getData()
  },
  watch: {
    '$route.query.id': {
      handler() {
        this.getData()
      },
      deep: true,
    },
  },
  methods: {
    toShop(e) {
      let url = e == 1 ? this.shop.tianmao_url : this.shop.weidian_url
      window.open(url)
    },
    prev() {
      let mySwiper = this.$refs.mySwiper.swiper
      mySwiper.slidePrev(300)
    },
    next() {
      let mySwiper = this.$refs.mySwiper.swiper
      mySwiper.slideNext(300)
    },
    todetail(id) {
      this.$router.push(`${this.$route.path}?id=${id}`)
    },
    getData() {
      this.axios
        .post('product/details', {
          id: this.$route.query.id,
        })
        .then((r) => {
          console.log(r)
          this.detail = {
            ...r,
          }
        })
    },
  },
}
</script>

<style lang="less" scoped>
.top {
  padding: 0.5rem 4.6rem;
  background: #ffffff;
  display: flex;

  font-weight: 400;

  & > * {
    width: 50%;
    height: 5.46rem;
  }
  /deep/.swiper-container {
    width: 5.46rem;
  }
  .image {
    background-size: 100% 100%;
    background-position: center;
    background-repeat: no-repeat;
    cursor: pointer;
    transition: all 0.3s linear;
    width: 5.46rem;
    height: 100%;
  }

  .image:hover {
    background-size: 110% 110%;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  }

  .right {
    padding-left: 0.48rem;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    width: calc(100% - 5.46rem);
    .logo {
      width: 1.85rem;
      height: 0.72rem;
      margin-bottom: 0.5rem;
    }

    .name {
      font-size: 20px;
      margin-bottom: 0.25rem;
      font-family: 'FZShuSong-Z01T';
    }

    & > span {
      margin-bottom: 0.13rem;
    }

    .no {
      font-size: 0.14rem;

      span {
        font-family: ' Baskerville Old Face';
      }
    }

    .price {
      margin: 0.41rem 0;
      border-top: 1px solid black;
      border-bottom: 1px solid black;
      font-size: 0.16rem;
      color: #997d46;
      text-align: center;
      padding: 0.1rem 0;
      position: relative;
      width: 100%;

      i {
        position: absolute;
        left: 0.2rem;
        top: 50%;
        transform: translateY(-50%);
      }
    }

    .call {
      padding: 0.14rem 0;
      width: 100%;
      position: relative;
      color: white;
      font-size: 0.18rem;
      text-align: center;
      cursor: pointer;
      background: linear-gradient(
        180deg,
        rgba(153, 125, 70, 1) 0%,
        rgba(188, 156, 96, 1) 100%
      );

      i {
        position: absolute;
        left: 0.2rem;
        top: 50%;
        transform: translateY(-50%);
      }
    }

    .btn {
      display: flex;
      justify-content: space-between;
      margin-top: 0.1rem;
      width: 100%;

      div {
        padding: 0.14rem 0;
        width: 49%;
        position: relative;
        font-size: 0.14rem;
        text-align: center;
        cursor: pointer;
        display: flex;
        justify-content: center;
        align-items: center;
        background: linear-gradient(
          180deg,
          rgba(255, 255, 255, 1) 0%,
          rgba(183, 182, 182, 1) 100%
        );
        position: relative;

        img {
          height: 0.15rem;
          margin-right: 0.05rem;
        }

        i {
          position: absolute;
          left: 0.2rem;
          top: 50%;
          transform: translateY(-50%);
        }
      }
    }
  }
}

.detail {
  padding: 0.6rem;
  box-sizing: border-box;
  background: #fbfbfb;

  h1 {
    font-size: 0.2rem;
    font-weight: 400;
    margin-bottom: 0.4rem;
  }

  video {
    width: 7.1rem;
    height: 4.39rem;
    margin: 0.5rem auto;
    display: block;
  }

  .rich {
    width: 11.24rem;
    margin: 0.32rem auto;
    line-height: 0.32rem;
    font-family: unset;
  }

  .desc {
    text-align: center;
  }

  ul {
    margin-top: 1.3rem;

    li {
      width: 10rem;
      margin: 0 auto;
      margin-bottom: 0.7rem;
      font-family: 'FZShuSong-Z01T';

      div {
        display: flex;
        user-select: none;
        justify-content: space-between;

        img,
        video {
          width: 6.1rem;
          height: 4.42rem;
          transition: all 0.3s linear;
          cursor: pointer;
        }

        img:hover {
          transform: scale(1.1, 1.1);
        }

        div {
          flex-direction: column;
          justify-content: center;
          width: 3rem;

          .title {
            font-size: 0.2rem;
            padding-bottom: 0.1rem;
            border-bottom: 1px solid rgba(0, 0, 0, 0.2);
            margin-bottom: 0.3rem;
          }

          .no {
            font-size: 0.16rem;
            font-family: 'Baskerville Old Face';
            margin-top: 0.11rem;
            margin-bottom: 0.27rem;
          }

          .desc {
            text-align: left;
            font-size: 0.14rem;
            margin-bottom: 1rem;
            line-height: 24px;
          }

          .more {
            font-size: 0.14rem;
            padding: 0.05rem;
            border-bottom: 0px solid rgba(33, 33, 33, 1);
            cursor: pointer;
            width: 0.9rem;
            transition: all 0.3s linear;
          }

          .more:hover {
            opacity: 0.5;
            border-bottom: 1px solid rgba(33, 33, 33, 1);
          }
        }
      }
    }
  }
}
.pagination {
  position: absolute;
  z-index: 1;
  text-align: center;
  bottom: 11px;
}
/deep/.dot {
  display: inline-block;
  width: 15px;
  height: 3px;
  background: #ffffff;
  opacity: 0.3;
  transition: all 0.15 linear;
}
/deep/.dot:not(:last-child) {
  margin-right: 5px;
}
/deep/.dot-active {
  opacity: 1;
}
.swiper-box {
  padding: 0 2.1rem;
  background: #ffffff;

  .title {
    font-size: 0.3rem;
    font-family: FZShuSong-Z01T;
    text-align: center;
  }

  hr {
    width: 1rem;
    margin: 0.4rem auto;
  }

  img {
    width: 2.25rem;
    height: 2.25rem;
    display: block;
    margin: 0 auto;
  }

  & > div {
    position: relative;

    i {
      position: absolute;
      top: 40%;
      transform: translateY(-50%);
      font-size: 0.3rem;
      cursor: pointer;
    }

    .right {
      right: -0.5rem;
    }

    .left {
      left: -0.5rem;
    }
  }

  .name {
    text-align: center;
    font-size: 0.14rem;
    font-family: FZShuSong-Z01T;
    margin: 0.2rem 0;
  }
}

@media (max-width: 767px) {
  .top {
    padding: 0;
    display: block;
    .image {
      width: 100%;
    }
    .swiper-container {
      width: 100vw;
      height: 100vw;
    }
    & > div {
      width: 100%;
    }

    .right {
      padding: 20px;
      justify-content: flex-start;
      width: 100%;
      height: auto;
      .logo {
        width: 30%;
        height: auto;
        margin-bottom: 20px;
      }

      .no {
        width: 100%;
        font-size: 16px;
        margin: 10px;
      }

      .price,
      .call {
        width: 100%;
        font-size: 14px;
        padding: 10px 0;
      }

      .btn {
        width: 100%;
        margin-top: 10px;
        div {
          font-size: 14px;
          padding: 5px 0;

          img {
            width: 15px;
            height: 15px;
          }
        }
      }
    }
  }

  .detail {
    h1 {
      font-size: 20px;
    }

    .rich {
      width: 100% !important;
      padding: 0;
    }

    ul {
      li {
        width: 100%;
        padding: 20px 10px;
        box-sizing: border-box;

        & > div {
          display: block;

          img,
          video {
            width: 100%;
            height: auto;
          }

          div {
            width: 100%;

            .title {
              font-size: 16px;
            }

            .desc {
              font-size: 12px;
              line-height: 20px;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 3;
            }
          }
        }
      }
    }
  }

  .swiper-box {
    padding: 0;

    .title {
      font-size: 20px;
    }

    hr {
      width: 50px;
    }

    img {
      height: 80px;
      width: 100%;
      object-fit: cover;
    }

    .name {
      font-size: 12px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/good-detail.vue